import { StyleConfig, PatternAngle, PointDiscreteGroup } from 'sdi/source';
import { nameToCode, IconName } from 'sdi/components/button/names';
import { getOriginColor, getCriticalityColor } from '../qa';
import { IssueTypeOsmObject } from 'qa/src/remote';
import RenderFeature from 'ol/render/Feature';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';

const pointGroup = (
    n: IconName,
    size: number,
    color: string,
    values: string[]
): PointDiscreteGroup => ({
    marker: {
        color,
        size,
        codePoint: nameToCode(n),
    },
    values,
    label: {},
});

const pointSizeRes = 0.4;
const pointSize = 32 + pointSizeRes;

export const issueStyleTypology = (): StyleConfig => ({
    kind: 'point-discrete',
    propName: 'origin',
    groups: [
        // pointGroup('circle-o', pointSize, 'gray', ['false']),
        pointGroup('circle', pointSize, getOriginColor('QA'), ['QA']),
        pointGroup(
            'circle',
            pointSize,
            getOriginColor('CHANGE_DETECTION_CREATION'),
            ['CHANGE_DETECTION_CREATION']
        ),
        pointGroup(
            'circle',
            pointSize,
            getOriginColor('CHANGE_DETECTION_MODIFICATION'),
            ['CHANGE_DETECTION_MODIFICATION']
        ),
        pointGroup(
            'circle',
            pointSize,
            getOriginColor('CREATION_OR_MODIFICATION'),
            ['CREATION_OR_MODIFICATION']
        ),
        pointGroup(
            'circle',
            pointSize,
            getOriginColor('CHANGE_DETECTION_DELETE'),
            ['CHANGE_DETECTION_DELETE']
        ),
        // pointGroup('circle', 14, getOriginColor('COMPARISON'), ['COMPARISON']),
        // pointGroup('circle', pointSize, getOriginColor('ROUTING'), ['ROUTING']),
    ],
});

export const issueStylePriority = (): StyleConfig => ({
    kind: 'point-discrete',
    propName: 'priority',
    groups: [
        pointGroup('circle', pointSize, getCriticalityColor('high'), ['high']),
        pointGroup('circle', pointSize, getCriticalityColor('medium'), [
            'medium',
        ]),
        pointGroup('circle', pointSize, getCriticalityColor('low'), ['low']),
    ],
});

export const getSelectedStyle = (feature: RenderFeature): Style[] => {
    const fill = new Fill({
        color: '#fada2f',
    });
    const stroke = new Stroke({
        width: 2,
        color: 'white',
    });
    return feature.getGeometry().getType() === 'Point'
        ? [
              new Style({
                  image: new Circle({
                      radius: 16,
                      fill: fill,
                      stroke: stroke,
                  }),
                  zIndex: 100,
              }),
          ]
        : [
              new Style({
                  stroke: stroke,
              }),
          ];
};

/* DEPRECATED */
// export const issueStyleTypologySelect = (): StyleConfig => ({
//     kind: 'point-discrete',
//     propName: 'origin',
//     groups: [
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getOriginColor('QA'),
//             ['QA']
//         ),
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getOriginColor('CHANGE_DETECTION_CREATION'),
//             ['CHANGE_DETECTION_CREATION']
//         ),
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getOriginColor('CHANGE_DETECTION_MODIFICATION'),
//             ['CHANGE_DETECTION_MODIFICATION']
//         ),
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getOriginColor('CHANGE_DETECTION_DELETE'),
//             ['CHANGE_DETECTION_DELETE']
//         ),
//         // pointGroup(
//         //     'circle', // 'circle-o',
//         //     14,
//         //     getOriginColor('COMPARISON'),
//         //     ['COMPARISON']
//         // ),
//         // pointGroup(
//         //     'circle', // 'circle-o',
//         //     Math.floor(pointSize * 1.6),
//         //     getOriginColor('ROUTING'),
//         //     ['ROUTING']
//         // ),
//     ],
// });

// export const issueStylePrioritySelect = (): StyleConfig => ({
//     kind: 'point-discrete',
//     propName: 'priority',
//     groups: [
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getCriticalityColor('high'),
//             ['high']
//         ),
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getCriticalityColor('medium'),
//             ['medium']
//         ),
//         pointGroup(
//             'circle', // 'circle-o',
//             Math.floor(pointSize * 1.6),
//             getCriticalityColor('low'),
//             ['low']
//         ),
//     ],
// });

export const iconNameForObject = (obj: IssueTypeOsmObject): IconName => {
    switch (obj) {
        default:
            return 'circle';
        case 'bicycle':
            return 'bicycle';
        case 'parking':
            return 'dot-circle';
        case 'intermodality':
            return 'arrows-alt';
        case 'service':
            return 'user';
        case 'structure':
            return 'circle';
        case 'energy':
            return 'cog';
    }
};

const iconGroup = (obj: IssueTypeOsmObject): PointDiscreteGroup => ({
    marker: {
        color: '#444444',
        size: Math.floor(pointSize * 0.6) + pointSizeRes,
        codePoint: nameToCode(iconNameForObject(obj)),
    },
    values: [obj],
    label: {},
});

export const issueStyleIcon = (): StyleConfig => ({
    kind: 'point-discrete',
    propName: 'object',
    groups: [
        iconGroup('bicycle'),
        iconGroup('parking'),
        // iconGroup('steps'),
        // iconGroup('foot-routing'),
        // iconGroup('lift'),
        // iconGroup('exit'),
        // iconGroup('emergency'),
        // iconGroup('restaurant'),
        // iconGroup('toilet'),
        // iconGroup('taxi'),
        // iconGroup('barrier'),
        iconGroup('structure'),
        iconGroup('service'),
        iconGroup('intermodality'),
        iconGroup('energy'),
        // iconGroup('street-furniture'),
        // iconGroup('shop'),
        // iconGroup('phone'),
        // iconGroup('parking'),
        // iconGroup('vending-machine'),
        // iconGroup('information-panel'),
    ],
});

export const osmPointStyle = (): StyleConfig => ({
    kind: 'point-discrete',
    propName: 'version',
    groups: [
        {
            marker: {
                color: 'rgb(59, 59, 59)',
                size: 11,
                codePoint: nameToCode('circle'), //nameToCode('circle-o')
            },
            values: ['previous'],
            label: {},
        },
        {
            marker: {
                color: 'rgb(73, 143, 225)',
                size: 11,
                codePoint: nameToCode('circle'), //nameToCode('circle-o')
            },
            values: ['current'],
            label: {},
        },
    ],
});

export const osmLineStyle = (): StyleConfig => ({
    kind: 'line-discrete',
    propName: 'version',
    groups: [
        {
            dash: [],
            strokeColor: 'rgb(209, 0, 0)',
            strokeWidth: 2,
            values: ['previous'],
            label: {},
        },
        {
            dash: [],
            strokeColor: 'rgb(38, 204, 16)',
            strokeWidth: 2,
            values: ['current'],
            label: {},
        },
    ],
});

export const osmPolygonStyle = (): StyleConfig => ({
    kind: 'polygon-discrete',
    propName: 'version',
    groups: [
        polyGroup('rgb(209, 0, 0)', 'rgba(209, 0, 0, 0.2)', ['previous']),
        polyGroup('rgb(38, 204, 16)', 'rgba(38, 204, 16, 0.2)', ['current']),
    ],
    // [
    //     {
    //         strokeColor: 'red',
    //         strokeWidth: 2,
    //         values: ['previous'],
    //         fillColor: 'red',
    //         pattern: true,
    //         patternAngle: 45,
    //         label: {},
    //     },
    //     {
    //         strokeColor: 'blue',
    //         strokeWidth: 2,
    //         values: ['current'],
    //         fillColor: 'blue',
    //         pattern: true,
    //         patternAngle: 0,
    //         label: {},
    //     }
    // ],
});

export const polyGroup = (
    strokeColor: string,
    fillColor: string,
    values: string[]
) => ({
    strokeColor,
    fillColor,
    strokeWidth: 1,
    values,
    pattern: { angle: 0 as PatternAngle, width: 0, color: 'white' },
    patternAngle: 0 as PatternAngle,
    label: {},
});
